<template>
  <common-header ref="CommonHeader"></common-header>
  <div id="smooth-wrapper">
    <div id="smooth-content">
      <router-view v-slot="{ Component }" @child-ready="ready">
      <component ref="viewer" :is="Component" />
    </router-view>
    <common-footer></common-footer>
    </div>
  </div>
  <loading ref="loading"></loading>
</template>

<script>
import Loading from '@/_components/Loading';
import CommonHeader from '@/_components/CommonHeader';
import CommonFooter from '@/_components/CommonFooter';

export default {
  components: {
    Loading,
    CommonHeader,
    CommonFooter,
  },
  data() {
    return {
      isReady: false,
      scrollY : 0,
      winH: window.innerHeight,
      logName: '',
    }
  },
  computed: {
    showLoad() {
      if (this.$store.getters.showLoad && this.$refs['CommonHeader']) {
        setTimeout(() => {
          this.$refs['CommonHeader'].forceClose();
        }, 500);
        
      }
     return this.$store.getters.showLoad;
    },
  },
  watch: {
    // ローディング表示フラグ監視
    showLoad (isShow, isOld) {
      if (isShow) {
        // 表示
        this.$refs['loading'].show();
      } else {
        // 非表示
        this.$refs['loading'].hide();
      }
    },
    scrollY : function(){
      let bottom = document.body.scrollHeight - this.winH;
      if (bottom <= this.scrollY) {
        this.$store.commit('sendGA', {action: 'click', path: '', label: `${this.logName} - ページ最下部までスクロール`});
      }
    },
    $route(to, from) {
      gFNS.rootHTML.classList.remove('is-page-series', 'is-page-top');
      if (to.name == 'index') {
        this.logName = 'トップページ';
        gFNS.rootHTML.classList.add('is-page-top');
      } else if (to.name == 'g20') {
        this.logName = 'Gold K18';
        gFNS.rootHTML.classList.add('is-page-series');
      } else if (to.name == 'npm10b') {
        this.logName = 'Tortoise Shell';
        gFNS.rootHTML.classList.add('is-page-series');
      } else if (to.name == 'np13bf') {
        this.logName = 'Buffalo Horn';
        gFNS.rootHTML.classList.add('is-page-series');
      } else if (to.name == 'en_index') {
        this.logName = 'en)トップページ';
        gFNS.rootHTML.classList.add('is-page-top');
      } else if (to.name == 'en_g20') {
        this.logName = 'en)Gold K18';
        gFNS.rootHTML.classList.add('is-page-series');
      } else if (to.name == 'en_npm10b') {
        this.logName = 'en)Tortoise Shell';
        gFNS.rootHTML.classList.add('is-page-series');
      } else if (to.name == 'en_np13bf') {
        this.logName = 'en)Buffalo Horn';
        gFNS.rootHTML.classList.add('is-page-series');
      } else {
        this.logName = '';
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    this.onResize();
  },
  methods: {
    once() {
      this.$refs['loading'].once();
    },
    ready(msg) {
      // router-viewのmounted完了
      if (this.isReady) return;
      this.isReady = true;
      this.$nextTick(this.once);
    },
    onResize() {
      this.winH = window.innerHeight;
      this.onScroll();
    },
    onScroll() {
      if (!this.isReady) return;
      this.scrollY = window.scrollY;
    }
  }
}
</script>